import { QuoteComparisonAnimation } from '@/components/quotes/QuoteComparisonAnimation/QuoteComparisonAnimation'
import { AppStoreBadges } from './AppStoreBadges'
import { CfoOverview } from './CfoOverview'
import { ProductTab } from './prototypeNav'

/** What the MVP account is, shared by the comparison pane and the full page. */
/** No CFO, no mascot: the first release answers to the brand. */
export const AGENT_NAME = 'Cai'

/** What the first release sells, named for the work rather than the job title. */
export const MVP_TABS = [ProductTab.BOOKKEEPER, ProductTab.INSURANCE, ProductTab.FUEL]

/** CFO is not an offer here: it is the page the agent pins its charts to. */
export const MVP_TAB_PAGES = {
  [ProductTab.CFO]: <CfoOverview teaser />,
}

/** Products that have something to show, not just a price. */
export const MVP_TAB_DETAIL = {
  [ProductTab.INSURANCE]: {
    preview: (
      <div className="flex h-56 w-full max-w-md items-center justify-center overflow-hidden">
        <QuoteComparisonAnimation className="w-[300px]" />
      </div>
    ),
    heading: 'See what your fleet would pay',
    lines: ['Quotes from the carriers that write for fleets your size, side by side.'],
    learnMore: 'https://www.cai.ai/insurance',
    learnMoreLabel: 'Learn more about Cai insurance',
  },
  [ProductTab.FUEL]: {
    heading: 'Get bigger discounts at the pump with FuelApp',
    placeholder: true,
    lines: ['Save up to $1/gallon at the nation’s largest truck stop networks.'],
    action: <AppStoreBadges />,
    learnMore: 'https://www.cai.ai/fuelapp',
    learnMoreLabel: 'Learn more about FuelApp',
  },
  [ProductTab.BOOKKEEPER]: {
    heading: 'See where your fleet’s money is really going',
    placeholder: true,
    lines: ['Catch up on the last few months available'],
    learnMore: 'https://www.cai.ai/bookkeeper',
    learnMoreLabel: 'Learn more about Cai bookkeeping',
  },
}

export const MVP_TAB_LABELS = {
  [ProductTab.BOOKKEEPER]: 'Bookkeeping',
  [ProductTab.FUEL]: 'Fuel Management',
}
